import { EventEmitter } from '@angular/core';
var ChipNotResponsiveComponent = (function () {
    function ChipNotResponsiveComponent() {
        this.selected = false;
        this.select = new EventEmitter();
    }
    ChipNotResponsiveComponent.prototype.ngOnInit = function () {
    };
    ChipNotResponsiveComponent.prototype.onclick = function (btn) {
        this.select.emit(this);
    };
    return ChipNotResponsiveComponent;
}());
export { ChipNotResponsiveComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chip-notResponsive/chip-notResponsive.component.ts.pre-build-optimizer.js